import { FunctionComponent, useEffect } from 'react'
import { useLocation, useHistory } from 'react-router-dom'
import { useGroupConsultationContext } from '@/modules/MyCalls/contexts/consultationGroupContext'
import { useStyles } from './styles'
import CustomLayout from '@/components/CustomLayout'
import { toast, Text } from '@conexasaude/conexa-hero'
import { GroupVideoRoomParams } from './types'

const GroupVideoRoom: FunctionComponent = () => {
  const location = useLocation<GroupVideoRoomParams>()
  const { groupConsultationData } = useGroupConsultationContext()
  const history = useHistory()
  const styles = useStyles()

  useEffect(() => {
    if (!location?.state) {
      toast({
        message:
          'O profisisonal não está na chamada, tente novamente mais tarde.',
        variant: 'error',
        autoCloseDuration: 5000,
      })
      setTimeout(() => {
        return history.push('/meus-atendimentos')
      }, 3000)
    }
  }, [location?.state, history])

  return (
    <CustomLayout>
      <div css={styles.container}>
        <div>
          <div css={styles.meetingHeader}>
            <Text variant="headingMedium">Videochamada</Text>
            <ul>
              <li>
                Tipo de consulta:{' '}
                <Text renderAs="span">
                  {groupConsultationData?.description}
                </Text>
              </li>
              <li>
                Especialidade:{' '}
                <Text renderAs="span">
                  {groupConsultationData?.professionalSpecialty}
                </Text>
              </li>
            </ul>
          </div>
        </div>
        <div>
          <div css={styles.containerWrapper}>
            <iframe
              src={location?.state?.meetingUrl}
              width="100%"
              height="550"
              name="meetConference"
              allow="camera; microphone; display-capture;"
              allowFullScreen
            />
          </div>
        </div>
      </div>
    </CustomLayout>
  )
}

export default GroupVideoRoom
